export const getBadgeKind = (badgeType: string) => {
  switch (badgeType) {
    case 'most-chosen':
      return 'info-outline';
    case 'eco':
      return 'success-outline';
    case 'recently-ordered':
      return 'primary-outline';
    case 'new':
    case 'premium':
      return 'primary';
    case 'cheapest':
      return 'warning';
    default:
      return 'info';
  }
};
